import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export interface RecommendedCategoriesHeaderProps {
  heroThumbnailImageUrl: string;
  headingText?: string;
  headingOverlineText?: string | null;
}

const RecommendedCategoriesHeader = ({
  heroThumbnailImageUrl,
  headingText = 'Based on your search',
  headingOverlineText = 'Try these next',
}: RecommendedCategoriesHeaderProps) => (
  <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
    {heroThumbnailImageUrl && (
      <Box
        component="img"
        src={heroThumbnailImageUrl}
        sx={{
          display: { md: 'none' },
          width: '5rem',
          height: '4.5rem',
          objectFit: 'cover',
          borderRadius: '1rem',
          whiteSpace: { md: 'nowrap' },
        }}
        alt="Recommended categories heading image of the selected vehicle"
      />
    )}
    <Stack spacing={0.5}>
      <Typography
        color="textSecondary"
        sx={{
          typography: {
            xs: 'caption',
            md: 'body2',
            whiteSpace: { md: 'nowrap' },
          },
        }}
      >
        {headingOverlineText}
      </Typography>
      <Typography
        component="h2"
        sx={{
          typography: { xs: 'h5', sm: 'h4' },
          whiteSpace: { md: 'nowrap' },
        }}
      >
        {headingText}
      </Typography>
    </Stack>
  </Stack>
);

export default RecommendedCategoriesHeader;
